import getInitStateArray from "./utils/initialState";
import findNeighbouringEnemies from "./utils/findNeighbouringEnemies";
import isSquareSpecialOrCapturer from "./utils/isSquareSpecialOrCapturer";

class Game {
  constructor(isAttacker: boolean) {
    this._state = getInitStateArray();
    this._isAttacker = isAttacker;
  }

  private _state: string[][];
  private _isAttacker;
  private _turn = 1;
  private _moveHistory: number[][] = [];
  private _isAttackersMove = true;
  private _isGameOver = false;
  private _isAttackerWinner: boolean | null = null;

  public processMove(
    startRow: number,
    startColumn: number,
    endRow: number,
    endColumn: number
  ) {
    if (this._isGameOver) return;
    // Move piece to new position
    this._state[endRow][endColumn] = this._state[startRow][startColumn];
    this._state[startRow][startColumn] = "o";
    this.checkForCaptures(endRow, endColumn);
    this.checkIfKingOnCorner(endRow, endColumn);
    this.checkIfNextOpponentHasValidMoves();

    this._moveHistory.push([startRow, startColumn, endRow, endColumn]);
    if (!this._isGameOver) {
      // Update metadata
      if (!this._isAttackersMove) {
        this._turn += 1;
      }
      this._isAttackersMove = !this._isAttackersMove;
    }
  }

  private checkIfKingOnCorner(row: number, column: number) {
    if (this._state[row][column] != "k") return;
    console.log(`row: ${row}, column: ${column}`);
    const isCorner = [0, 10].includes(row) && [0, 10].includes(column);
    console.log(`isCorner: ${isCorner}`);
    if (isCorner) {
      console.log("Game over: the defender wins!");
      this._isGameOver = true;
      this._isAttackerWinner = false;
    }
  }

  private checkForCaptures(row: number, column: number) {
    const capturer = this._isAttackersMove ? "a" : "dk";
    const target = this._isAttackersMove ? "dk" : "a";
    const neighbouringEnemies = findNeighbouringEnemies(
      this._state,
      row,
      column,
      target
    );

    for (const enemyOffset of neighbouringEnemies) {
      const enemyRow = row + enemyOffset[0];
      const enemyColumn = column + enemyOffset[1];
      const enemy = this._state[enemyRow][enemyColumn];
      if ("ad".includes(enemy)) {
        // Attempting to capture a 'regular' enemy, i.e. not the king.
        const opposingRow = enemyRow + enemyOffset[0];
        const opposingColumn = enemyColumn + enemyOffset[1];
        if (
          isSquareSpecialOrCapturer(
            this._state,
            opposingRow,
            opposingColumn,
            capturer
          )
        ) {
          // The enemy is captured!
          this._state[enemyRow][enemyColumn] = "o";
        }
      } else {
        // Attempting to capture the king!
        let hasFreeSpace = false;
        for (const [_row, _column] of [
          [0, 1],
          [1, 0],
          [0, -1],
          [-1, 0],
        ]) {
          if (
            !isSquareSpecialOrCapturer(
              this._state,
              enemyRow + _row,
              enemyColumn + _column,
              capturer
            )
          ) {
            hasFreeSpace = true;
          }
        }
        if (!hasFreeSpace) {
          console.log("Game over: the attackers win!");
          this._state[enemyRow][enemyColumn] = "o";
          this._isGameOver = true;
          this._isAttackerWinner = true;
        }
      }
    }
  }

  private checkIfNextOpponentHasValidMoves() {
    const opponentsPieces = this._isAttackersMove ? "dk" : "a";
    for (const row of Array.from(Array(11).keys())) {
      for (const col of Array.from(Array(11).keys())) {
        if (!opponentsPieces.includes(this._state[row][col])) {
          continue;
        }
        for (const [rowOffset, colOffset] of [
          [0, 1],
          [1, 0],
          [0, -1],
          [-1, 0],
        ]) {
          const _row = row + rowOffset;
          const _col = col + colOffset;
          console.log(`checking row ${row}, column ${col}`);
          if (!isSquareSpecialOrCapturer(this._state, _row, _col, "adk")) {
            return;
          }
        }
      }
    }
    // The opponent has no valid moves
    console.log(
      `Game over: the ${this._isAttackersMove ? "attacker" : "defender"} wins!`
    );
    this._isGameOver = true;
    this._isAttackerWinner = this._isAttackersMove;
  }

  get state(): string[][] {
    return this._state;
  }

  get turn(): number {
    return this._turn;
  }

  get moveHistory(): number[][] {
    return this._moveHistory;
  }

  get isMyTurn(): boolean {
    return this._isAttacker == this._isAttackersMove;
  }

  get myPieces(): string {
    return this._isAttackersMove ? "a" : "dk";
  }

  get isGameOver(): boolean {
    return this._isGameOver;
  }

  get isAttackerWinner(): boolean | null {
    return this._isAttackerWinner;
  }

  public toString = (): string => {
    let str = "";
    let i = 11;
    this.state.forEach((line) => {
      str += i > 9 ? `\n${i}|` : `\n ${i}|`;
      str += line.join("");
      i -= 1;
    });
    str += "\n   abcdefghijk";
    return str;
  };
}

export default Game;
